module.exports = __webpack_public_path__ + "static/media/4931-16.9a036c36.jpg";